import React from 'react';

const fetchProtectedData = async () => {
  const token = localStorage.getItem("access_token");
  if (!token) {
    throw new Error("No token found. Please log in.");
  }

  try {
    const response = await fetch("api/users/protected-route", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,  // Send token in the Authorization header
      },
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error!`);
    }

    const data = await response.json();
    if (data.ok) {
      return data.user_id
    }
    throw new Error("Failed to fetch protected data");

  } catch (err) {
    throw new Error("Network error");
}
};

export default fetchProtectedData;
